var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React, { useState } from 'react';
import { Translate, I18NApi } from "../../../../../I18N";

import { Button, Modal, SearchMultiselect } from "../../../../Components/UI";

import { RequestParams } from "../../../../../utils/RequestParams";
import { useApiCaller } from "../../../../CustomHooks/useApiCaller";






const InstallLanguagesModal = ({ setShowModal, languages }) => {
  const [selected, setSelected] = useState([]);
  const { requestAction } = useApiCaller();

  const items = languages.map((l) => ({
    label: `${l.translationAvailable ? ' * ' : ''}${l.label} (${l.key})`,
    value: l.key
  }));

  const install = async () => {
    await requestAction(
      I18NApi.addLanguage,
      new RequestParams(languages.filter((l) => selected.includes(l.key))), /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Languages installed successfully")
    );
  };

  return /*#__PURE__*/(
    _jsx(Modal, { size: "lg" }, void 0, /*#__PURE__*/
    _jsx(Modal.Header, {}, void 0, /*#__PURE__*/
    _jsx("h1", { className: "text-xl font-medium text-gray-900" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Install Language(s)")
    ), /*#__PURE__*/
    _jsx(Modal.CloseButton, { onClick: () => setShowModal(false) })
    ), /*#__PURE__*/
    _jsx(Modal.Body, { className: "pt-4" }, void 0, /*#__PURE__*/
    _jsx(Translate, { className: "block px-2 text-justify text-gray-700" }, void 0, "This action may take some time while we add the extra language to the entire collection."

    ), /*#__PURE__*/
    _jsx(SearchMultiselect, {
      className: "pt-4 max-h-96 ",
      items: items,
      onChange: (s) => setSelected(s) }
    )
    ), /*#__PURE__*/
    _jsx(Modal.Footer, {}, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex flex-col w-full" }, void 0, /*#__PURE__*/
    _jsx("p", { className: "w-full pt-0 pb-3 text-sm font-normal text-gray-500 dark:text-gray-400" }, void 0, "* ", /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Available default translation")
    ), /*#__PURE__*/
    _jsx("div", { className: "flex gap-2" }, void 0, /*#__PURE__*/
    _jsx(Button, { styling: "light", onClick: () => setShowModal(false), className: "grow" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Cancel")
    ), /*#__PURE__*/
    _jsx(Button, {
      onClick: async () => {
        setShowModal(false);
        await install();
      },
      className: "grow",
      disabled: !selected.length }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Install"), " ", selected.length ? `(${selected.length})` : ''
    )
    )
    )
    )
    ));

};

export { InstallLanguagesModal };